"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gbZones = void 0;
var gbZones = exports.gbZones = [{
  id: 'BIRMINGHAM',
  name: 'Birmingham',
  country: 'UK',
  cornerNW: {
    latitude: 52.5438,
    longitude: -1.9936
  },
  cornerSE: {
    latitude: 52.4089,
    longitude: -1.7729
  },
  subZones: [{
    name: 'Birmingham',
    zipcodes: {
      B1: {
        label: 'City Centre'
      },
      B2: {
        label: 'Ladywood'
      },
      B3: {
        label: 'Jewellery Quarter'
      },
      B4: {
        label: 'Aston'
      },
      B5: {
        label: 'Digbeth'
      }
    }
  }]
}, {
  id: 'BRISTOL',
  name: 'Bristol',
  country: 'UK',
  cornerNW: {
    latitude: 51.5007,
    longitude: -2.6597
  },
  cornerSE: {
    latitude: 51.4167,
    longitude: -2.5255
  },
  subZones: [{
    name: 'Bristol',
    zipcodes: {
      BS1: {
        label: 'City Centre'
      },
      BS2: {
        label: 'St Pauls'
      },
      BS3: {
        label: 'Bedminster'
      },
      BS6: {
        label: 'Redland'
      },
      BS8: {
        label: 'Clifton'
      }
    }
  }]
}, {
  id: 'EDINBURGH',
  name: 'Edinburgh',
  country: 'UK',
  cornerNW: {
    latitude: 55.9898,
    longitude: -3.2597
  },
  cornerSE: {
    latitude: 55.9127,
    longitude: -3.1251
  },
  subZones: [{
    name: 'Edinburgh',
    zipcodes: {
      EH1: {
        label: 'Old Town'
      },
      EH2: {
        label: 'New Town'
      },
      EH3: {
        label: 'West End'
      },
      EH8: {
        label: 'Holyrood'
      },
      EH10: {
        label: 'Morningside'
      }
    }
  }]
}, {
  id: 'GLASGOW',
  name: 'Glasgow',
  country: 'UK',
  cornerNW: {
    latitude: 55.9067,
    longitude: -4.3931
  },
  cornerSE: {
    latitude: 55.8144,
    longitude: -4.2059
  },
  subZones: [{
    name: 'Glasgow',
    zipcodes: {
      G1: {
        label: 'Glasgow City Centre'
      },
      G2: {
        label: 'Merchant City'
      },
      G3: {
        label: 'Finnieston'
      },
      G4: {
        label: 'Dennistoun'
      },
      G5: {
        label: 'Gorbals'
      }
    }
  }]
}, {
  id: 'LEEDS',
  name: 'Leeds',
  country: 'UK',
  cornerNW: {
    latitude: 53.8463,
    longitude: -1.6044
  },
  cornerSE: {
    latitude: 53.7276,
    longitude: -1.4778
  },
  subZones: [{
    name: 'Leeds',
    zipcodes: {
      LS1: {
        label: 'Leeds City Centre'
      },
      LS2: {
        label: 'Leeds University'
      },
      LS6: {
        label: 'Headingley'
      },
      LS8: {
        label: 'Roundhay'
      },
      LS11: {
        label: 'Beeston'
      }
    }
  }]
}, {
  id: 'LIVERPOOL',
  name: 'Liverpool',
  country: 'UK',
  cornerNW: {
    latitude: 53.4508,
    longitude: -3.0181
  },
  cornerSE: {
    latitude: 53.3345,
    longitude: -2.8519
  },
  subZones: [{
    name: 'Liverpool',
    zipcodes: {
      L1: {
        label: 'Liverpool City Centre'
      },
      L2: {
        label: 'Commercial District'
      },
      L3: {
        label: 'Waterfront'
      },
      L4: {
        label: 'Anfield'
      },
      L5: {
        label: 'Everton'
      }
    }
  }]
}, {
  id: 'LONDON',
  name: 'Londres',
  country: 'UK',
  cornerNW: {
    latitude: 51.6723432,
    longitude: -0.4689899
  },
  cornerSE: {
    latitude: 51.28676,
    longitude: 0.2771377
  },
  deliveryFee: 8,
  subZones: [{
    name: 'Eastern',
    zipcodes: {
      E1: {
        label: 'E1'
      },
      E2: {
        label: 'E2'
      },
      E3: {
        label: 'E3'
      },
      E4: {
        label: 'E4'
      },
      E5: {
        label: 'E5'
      },
      E6: {
        label: 'E6'
      },
      E7: {
        label: 'E7'
      },
      E8: {
        label: 'E8'
      },
      E9: {
        label: 'E9'
      },
      E10: {
        label: 'E10'
      },
      E11: {
        label: 'E11'
      },
      E12: {
        label: 'E12'
      },
      E13: {
        label: 'E13'
      },
      E14: {
        label: 'E14'
      },
      E15: {
        label: 'E15'
      },
      E16: {
        label: 'E16'
      },
      E17: {
        label: 'E17'
      },
      E18: {
        label: 'E18'
      },
      E1W: {
        label: 'E1W'
      },
      E20: {
        label: 'E20'
      },
      E22: {
        label: 'E22'
      },
      E98: {
        label: 'E98'
      }
    }
  }, {
    name: 'Eastern Central',
    zipcodes: {
      EC1A: {
        label: 'EC1A'
      },
      EC1M: {
        label: 'EC1M'
      },
      EC1N: {
        label: 'EC1N'
      },
      EC1P: {
        label: 'EC1P'
      },
      EC1R: {
        label: 'EC1R'
      },
      EC1V: {
        label: 'EC1V'
      },
      EC1Y: {
        label: 'EC1Y'
      },
      EC2A: {
        label: 'EC2A'
      },
      EC2M: {
        label: 'EC2M'
      },
      EC2N: {
        label: 'EC2N'
      },
      EC2P: {
        label: 'EC2P'
      },
      EC2R: {
        label: 'EC2R'
      },
      EC2V: {
        label: 'EC2V'
      },
      EC2Y: {
        label: 'EC2Y'
      },
      EC3A: {
        label: 'EC3A'
      },
      EC3M: {
        label: 'EC3M'
      },
      EC3N: {
        label: 'EC3N'
      },
      EC3P: {
        label: 'EC3P'
      },
      EC3R: {
        label: 'EC3R'
      },
      EC3V: {
        label: 'EC3V'
      },
      EC4A: {
        label: 'EC4A'
      },
      EC4M: {
        label: 'EC4M'
      },
      EC4N: {
        label: 'EC4N'
      },
      EC4P: {
        label: 'EC4P'
      },
      EC4R: {
        label: 'EC4R'
      },
      EC4V: {
        label: 'EC4V'
      },
      EC4Y: {
        label: 'EC4Y'
      }
    }
  }, {
    name: 'Northern',
    zipcodes: {
      N1: {
        label: 'N1'
      },
      N2: {
        label: 'N2'
      },
      N3: {
        label: 'N3'
      },
      N4: {
        label: 'N4'
      },
      N5: {
        label: 'N5'
      },
      N6: {
        label: 'N6'
      },
      N7: {
        label: 'N7'
      },
      N8: {
        label: 'N8'
      },
      N9: {
        label: 'N9'
      },
      N10: {
        label: 'N10'
      },
      N11: {
        label: 'N11'
      },
      N12: {
        label: 'N12'
      },
      N13: {
        label: 'N13'
      },
      N14: {
        label: 'N14'
      },
      N15: {
        label: 'N15'
      },
      N16: {
        label: 'N16'
      },
      N17: {
        label: 'N17'
      },
      N18: {
        label: 'N18'
      },
      N19: {
        label: 'N19'
      },
      N1C: {
        label: 'N1C'
      },
      N1P: {
        label: 'N1P'
      },
      N20: {
        label: 'N20'
      },
      N21: {
        label: 'N21'
      },
      N22: {
        label: 'N22'
      },
      N81: {
        label: 'N81'
      }
    }
  }, {
    name: 'North Western',
    zipcodes: {
      NW1: {
        label: 'NW1'
      },
      NW2: {
        label: 'NW2'
      },
      NW3: {
        label: 'NW3'
      },
      NW4: {
        label: 'NW4'
      },
      NW5: {
        label: 'NW5'
      },
      NW6: {
        label: 'NW6'
      },
      NW7: {
        label: 'NW7'
      },
      NW8: {
        label: 'NW8'
      },
      NW9: {
        label: 'NW9'
      },
      NW10: {
        label: 'NW10'
      },
      NW11: {
        label: 'NW11'
      },
      NW1W: {
        label: 'NW1W'
      },
      NW26: {
        label: 'NW26'
      }
    }
  }, {
    name: 'South Eastern',
    zipcodes: {
      SE1: {
        label: 'SE1'
      },
      SE2: {
        label: 'SE2'
      },
      SE3: {
        label: 'SE3'
      },
      SE4: {
        label: 'SE4'
      },
      SE5: {
        label: 'SE5'
      },
      SE6: {
        label: 'SE6'
      },
      SE7: {
        label: 'SE7'
      },
      SE8: {
        label: 'SE8'
      },
      SE9: {
        label: 'SE9'
      },
      SE10: {
        label: 'SE10'
      },
      SE11: {
        label: 'SE11'
      },
      SE12: {
        label: 'SE12'
      },
      SE13: {
        label: 'SE13'
      },
      SE14: {
        label: 'SE14'
      },
      SE15: {
        label: 'SE15'
      },
      SE16: {
        label: 'SE16'
      },
      SE17: {
        label: 'SE17'
      },
      SE18: {
        label: 'SE18'
      },
      SE19: {
        label: 'SE19'
      },
      SE1P: {
        label: 'SE1P'
      },
      SE20: {
        label: 'SE20'
      },
      SE21: {
        label: 'SE21'
      },
      SE22: {
        label: 'SE22'
      },
      SE23: {
        label: 'SE23'
      },
      SE24: {
        label: 'SE24'
      },
      SE25: {
        label: 'SE25'
      },
      SE26: {
        label: 'SE26'
      },
      SE27: {
        label: 'SE27'
      },
      SE28: {
        label: 'SE28'
      }
    }
  }, {
    name: 'South Western',
    zipcodes: {
      SW2: {
        label: 'SW2'
      },
      SW3: {
        label: 'SW3'
      },
      SW4: {
        label: 'SW4'
      },
      SW5: {
        label: 'SW5'
      },
      SW6: {
        label: 'SW6'
      },
      SW7: {
        label: 'SW7'
      },
      SW8: {
        label: 'SW8'
      },
      SW9: {
        label: 'SW9'
      },
      SW10: {
        label: 'SW10'
      },
      SW11: {
        label: 'SW11'
      },
      SW12: {
        label: 'SW12'
      },
      SW13: {
        label: 'SW13'
      },
      SW14: {
        label: 'SW14'
      },
      SW15: {
        label: 'SW15'
      },
      SW16: {
        label: 'SW16'
      },
      SW17: {
        label: 'SW17'
      },
      SW18: {
        label: 'SW18'
      },
      SW19: {
        label: 'SW19'
      },
      SW1A: {
        label: 'SW1A'
      },
      SW1E: {
        label: 'SW1E'
      },
      SW1H: {
        label: 'SW1H'
      },
      SW1P: {
        label: 'SW1P'
      },
      SW1V: {
        label: 'SW1V'
      },
      SW1W: {
        label: 'SW1W'
      },
      SW1X: {
        label: 'SW1X'
      },
      SW1Y: {
        label: 'SW1Y'
      },
      SW20: {
        label: 'SW20'
      },
      SW95: {
        label: 'SW95'
      }
    }
  }, {
    name: 'Western and Paddington',
    zipcodes: {
      W2: {
        label: 'W2'
      },
      W3: {
        label: 'W3'
      },
      W4: {
        label: 'W4'
      },
      W5: {
        label: 'W5'
      },
      W6: {
        label: 'W6'
      },
      W7: {
        label: 'W7'
      },
      W8: {
        label: 'W8'
      },
      W9: {
        label: 'W9'
      },
      W10: {
        label: 'W10'
      },
      W11: {
        label: 'W11'
      },
      W12: {
        label: 'W12'
      },
      W13: {
        label: 'W13'
      },
      W14: {
        label: 'W14'
      },
      W1A: {
        label: 'W1A'
      },
      W1B: {
        label: 'W1B'
      },
      W1C: {
        label: 'W1C'
      },
      W1D: {
        label: 'W1D'
      },
      W1F: {
        label: 'W1F'
      },
      W1G: {
        label: 'W1G'
      },
      W1H: {
        label: 'W1H'
      },
      W1J: {
        label: 'W1J'
      },
      W1K: {
        label: 'W1K'
      },
      W1S: {
        label: 'W1S'
      },
      W1T: {
        label: 'W1T'
      },
      W1U: {
        label: 'W1U'
      },
      W1W: {
        label: 'W1W'
      }
    }
  }, {
    name: 'Western Central',
    zipcodes: {
      WC1A: {
        label: 'WC1A'
      },
      WC1B: {
        label: 'WC1B'
      },
      WC1E: {
        label: 'WC1E'
      },
      WC1H: {
        label: 'WC1H'
      },
      WC1N: {
        label: 'WC1N'
      },
      WC1R: {
        label: 'WC1R'
      },
      WC1V: {
        label: 'WC1V'
      },
      WC1X: {
        label: 'WC1X'
      },
      WC2A: {
        label: 'WC2A'
      },
      WC2B: {
        label: 'WC2B'
      },
      WC2E: {
        label: 'WC2E'
      },
      WC2H: {
        label: 'WC2H'
      },
      WC2N: {
        label: 'WC2N'
      },
      WC2R: {
        label: 'WC2R'
      }
    }
  }, {
    name: 'Bromley',
    zipcodes: {
      BR1: {
        label: 'BR1'
      },
      BR2: {
        label: 'BR2'
      },
      BR3: {
        label: 'BR3'
      },
      BR4: {
        label: 'BR4'
      },
      BR5: {
        label: 'BR5'
      },
      BR6: {
        label: 'BR6'
      },
      BR7: {
        label: 'BR7'
      },
      BR8: {
        label: 'BR8'
      }
    }
  }, {
    name: 'Croydon',
    zipcodes: {
      CR0: {
        label: 'CR0'
      },
      CR2: {
        label: 'CR2'
      },
      CR3: {
        label: 'CR3'
      },
      CR4: {
        label: 'CR4'
      },
      CR5: {
        label: 'CR5'
      },
      CR6: {
        label: 'CR6'
      },
      CR7: {
        label: 'CR7'
      },
      CR8: {
        label: 'CR8'
      },
      CR9: {
        label: 'CR9'
      },
      CR90: {
        label: 'CR90'
      }
    }
  }, {
    name: 'Dartford',
    zipcodes: {
      DA1: {
        label: 'DA1'
      },
      DA5: {
        label: 'DA5'
      },
      DA6: {
        label: 'DA6'
      },
      DA7: {
        label: 'DA7'
      },
      DA8: {
        label: 'DA8'
      },
      DA14: {
        label: 'DA14'
      },
      DA15: {
        label: 'DA15'
      },
      DA16: {
        label: 'DA16'
      },
      DA17: {
        label: 'DA17'
      },
      DA18: {
        label: 'DA18'
      }
    }
  }, {
    name: 'Enfield',
    zipcodes: {
      EN1: {
        label: 'EN1'
      },
      EN2: {
        label: 'EN2'
      },
      EN3: {
        label: 'EN3'
      },
      EN4: {
        label: 'EN4'
      },
      EN5: {
        label: 'EN5'
      },
      EN6: {
        label: 'EN6'
      },
      EN7: {
        label: 'EN7'
      },
      EN8: {
        label: 'EN8'
      },
      EN9: {
        label: 'EN9'
      }
    }
  }, {
    name: 'Harrow',
    zipcodes: {
      HA0: {
        label: 'HA0'
      },
      HA1: {
        label: 'HA1'
      },
      HA2: {
        label: 'HA2'
      },
      HA3: {
        label: 'HA3'
      },
      HA4: {
        label: 'HA4'
      },
      HA5: {
        label: 'HA5'
      },
      HA6: {
        label: 'HA6'
      },
      HA7: {
        label: 'HA7'
      },
      HA8: {
        label: 'HA8'
      },
      HA9: {
        label: 'HA9'
      }
    }
  }, {
    name: 'Ilford',
    zipcodes: {
      IG1: {
        label: 'IG1'
      },
      IG2: {
        label: 'IG2'
      },
      IG3: {
        label: 'IG3'
      },
      IG4: {
        label: 'IG4'
      },
      IG5: {
        label: 'IG5'
      },
      IG6: {
        label: 'IG6'
      },
      IG7: {
        label: 'IG7'
      },
      IG8: {
        label: 'IG8'
      },
      IG9: {
        label: 'IG9'
      },
      IG11: {
        label: 'IG11'
      }
    }
  }, {
    name: 'Kingston upon Thames',
    zipcodes: {
      KT1: {
        label: 'KT1'
      },
      KT2: {
        label: 'KT2'
      },
      KT3: {
        label: 'KT3'
      },
      KT4: {
        label: 'KT4'
      },
      KT5: {
        label: 'KT5'
      },
      KT6: {
        label: 'KT6'
      },
      KT7: {
        label: 'KT7'
      },
      KT8: {
        label: 'KT8'
      },
      KT9: {
        label: 'KT9'
      },
      KT17: {
        label: 'KT17'
      },
      KT18: {
        label: 'KT18'
      },
      KT19: {
        label: 'KT19'
      },
      KT22: {
        label: 'KT22'
      }
    }
  }, {
    name: 'Romford',
    zipcodes: {
      RM1: {
        label: 'RM1'
      },
      RM2: {
        label: 'RM2'
      },
      RM3: {
        label: 'RM3'
      },
      RM4: {
        label: 'RM4'
      },
      RM5: {
        label: 'RM5'
      },
      RM6: {
        label: 'RM6'
      },
      RM7: {
        label: 'RM7'
      },
      RM8: {
        label: 'RM8'
      },
      RM9: {
        label: 'RM9'
      },
      RM10: {
        label: 'RM10'
      },
      RM11: {
        label: 'RM11'
      },
      RM12: {
        label: 'RM12'
      },
      RM13: {
        label: 'RM13'
      },
      RM14: {
        label: 'RM14'
      },
      RM15: {
        label: 'RM15'
      }
    }
  }, {
    name: 'Sutton',
    zipcodes: {
      SM1: {
        label: 'SM1'
      },
      SM2: {
        label: 'SM2'
      },
      SM3: {
        label: 'SM3'
      },
      SM4: {
        label: 'SM4'
      },
      SM5: {
        label: 'SM5'
      },
      SM6: {
        label: 'SM6'
      },
      SM7: {
        label: 'SM7'
      }
    }
  }, {
    name: 'Tunbridge Wells',
    zipcodes: {
      TN14: {
        label: 'TN14'
      },
      TN16: {
        label: 'TN16'
      }
    }
  }, {
    name: 'Twickenham',
    zipcodes: {
      TW1: {
        label: 'TW1'
      },
      TW2: {
        label: 'TW2'
      },
      TW3: {
        label: 'TW3'
      },
      TW4: {
        label: 'TW4'
      },
      TW5: {
        label: 'TW5'
      },
      TW6: {
        label: 'TW6'
      },
      TW7: {
        label: 'TW7'
      },
      TW8: {
        label: 'TW8'
      },
      TW9: {
        label: 'TW9'
      },
      TW10: {
        label: 'TW10'
      },
      TW11: {
        label: 'TW11'
      },
      TW12: {
        label: 'TW12'
      },
      TW13: {
        label: 'TW13'
      },
      TW14: {
        label: 'TW14'
      },
      TW15: {
        label: 'TW15'
      },
      TW19: {
        label: 'TW19'
      }
    }
  }, {
    name: 'Southall',
    zipcodes: {
      UB1: {
        label: 'UB1'
      },
      UB2: {
        label: 'UB2'
      },
      UB3: {
        label: 'UB3'
      },
      UB4: {
        label: 'UB4'
      },
      UB5: {
        label: 'UB5'
      },
      UB6: {
        label: 'UB6'
      },
      UB7: {
        label: 'UB7'
      },
      UB8: {
        label: 'UB8'
      },
      UB9: {
        label: 'UB9'
      },
      UB10: {
        label: 'UB10'
      },
      UB11: {
        label: 'UB11'
      },
      UB18: {
        label: 'UB18'
      }
    }
  }, {
    name: 'Watford',
    zipcodes: {
      WD3: {
        label: 'WD3'
      },
      WD6: {
        label: 'WD6'
      },
      WD23: {
        label: 'WD23'
      }
    }
  }]
}, {
  id: 'MANCHESTER',
  name: 'Manchester',
  country: 'UK',
  cornerNW: {
    latitude: 53.5279,
    longitude: -2.2988
  },
  cornerSE: {
    latitude: 53.4039,
    longitude: -2.1879
  },
  subZones: [{
    name: 'Manchester',
    zipcodes: {
      M1: {
        label: 'Manchester City Centre'
      },
      M11: {
        label: 'Clayton'
      },
      M14: {
        label: 'Fallowfield'
      },
      M20: {
        label: 'Didsbury'
      },
      M4: {
        label: 'Northern Quarter'
      }
    }
  }]
}, {
  id: 'NEWCASTLE',
  name: 'Newcastle',
  country: 'UK',
  cornerNW: {
    latitude: 55.0183,
    longitude: -1.7062
  },
  cornerSE: {
    latitude: 54.9577,
    longitude: -1.5501
  },
  subZones: [{
    name: 'Newcastle',
    zipcodes: {
      NE1: {
        label: 'City Centre'
      },
      NE2: {
        label: 'Jesmond'
      },
      NE3: {
        label: 'Gosforth'
      },
      NE4: {
        label: 'Fenham'
      },
      NE6: {
        label: 'Walker'
      }
    }
  }]
}, {
  id: 'SHEFFIELD',
  name: 'Sheffield',
  country: 'UK',
  cornerNW: {
    latitude: 53.4208,
    longitude: -1.5301
  },
  cornerSE: {
    latitude: 53.3206,
    longitude: -1.4124
  },
  subZones: [{
    name: 'Sheffield',
    zipcodes: {
      S1: {
        label: 'City Centre'
      },
      S2: {
        label: 'Norfolk Park'
      },
      S3: {
        label: 'Kelham Island'
      },
      S6: {
        label: 'Hillsborough'
      },
      S10: {
        label: 'Broomhill'
      }
    }
  }]
}];